import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class Visualizer extends Component {
  constructor(obj) {
    super(obj)

    gsap.set(this.el, { autoAlpha: 0 })
    this.animate()
  }

  animate() {
    const bg = qs(".try-it", this.el)
    const title = qs(".title", this.el)
    const description = qs(".description", this.el)
    const cta = qs(".try-it-btn", this.el)

    gsap.set([title, description, cta], {
      autoAlpha: 0,
    })

    gsap.fromTo(
      bg,
      {
        width: 0,
        height: 0,
      },
      {
        duration: 1.2,
        width: "100%",
        height: "100%",
        scrollTrigger: {
          trigger: bg,
          start: "top bottom",
          onEnter: () => {
            gsap.to([title, description, cta], {
              autoAlpha: 1,
              delay: 0.5,
            })
          },
        },
      }
    )

    gsap.set(this.el, { autoAlpha: 1 })
  }
}
